import { useMutationHook, useQueryHook } from "@/hooks"
import {
  readFilterPresets,
  readFilterPresetDetail,
  createFilterPreset,
  updateFilterPreset,
  deleteFilterPreset,
} from "@/app/api/filterPreset"
import type {
  FilterPreset,
  FilterPresetSummary,
  UpsertFilterPresetPayload,
} from "@/types/filterPreset"
import { UseQueryOptions } from "@tanstack/react-query"
import { ApiError } from "@/app/api/type"

/** 프리셋 목록 조회 */
export const useFilterPresetsQuery = (enabled = true) => {
  return useQueryHook<FilterPresetSummary[], unknown>({
    queryKey: ["readFilterPresets"],
    queryFn: () => readFilterPresets(),
    options: { enabled } as UseQueryOptions<FilterPresetSummary[], ApiError>,
  })
}

/** 프리셋 상세 조회 */
export const useFilterPresetDetailQuery = (idfPreset?: number | null) => {
  return useQueryHook<FilterPreset, unknown>({
    queryKey: ["readFilterPresetDetail", idfPreset],
    queryFn: () => readFilterPresetDetail(idfPreset!),
    options: { enabled: !!idfPreset } as UseQueryOptions<FilterPreset, ApiError>,
  })
}

/** 프리셋 생성 */
export const useCreateFilterPresetMutation = () => {
  return useMutationHook(createFilterPreset, [["readFilterPresets"]])
}

/** 프리셋 수정 */
export const useUpdateFilterPresetMutation = () => {
  return useMutationHook(
    ({ idfPreset, payload }: { idfPreset: number; payload: UpsertFilterPresetPayload }) =>
      updateFilterPreset(idfPreset, payload),
    [["readFilterPresets"], ["readFilterPresetDetail"]],
  )
}

/** 프리셋 삭제 */
export const useDeleteFilterPresetMutation = () => {
  return useMutationHook(deleteFilterPreset, [["readFilterPresets"]])
}
